import { Record } from 'immutable'

export interface IPotentialProfit {
  readonly completionProbability: number
  readonly contactId: string
  readonly estimatedProfit: number
  readonly potentialProfit: number
}

const PotentialProfitRecord = Record({
  completionProbability: 0,
  contactId: '',
  estimatedProfit: 0,
  potentialProfit: 0,
})

export class PotentialProfit extends PotentialProfitRecord
  implements IPotentialProfit {
  public static fromJS(initialState?: Partial<IPotentialProfit>) {
    return new PotentialProfit(initialState)
  }

  public readonly completionProbability: number
  public readonly contactId: string
  public readonly estimatedProfit: number
  public readonly potentialProfit: number

  constructor(props?: Partial<PotentialProfit>) {
    props ? super(props) : super()
  }
}
